<section class="forgotpassword">
    <div class="forgotpassword__upper-content">
        <div class="forgotpassword__label">{{ 'INFO.FORGOT_PASSWORD' | translate }}</div>
        <div class="forgotpassword__links links">
            <p class="links__text">{{ 'INFO.NOTE_001' | translate }}</p>
            <a class="links__button" routerLink="/login">{{ 'INFO.SIGN_IN' | translate }}</a>
        </div>
    </div>
    <form class="forgotpassword__main-content" [formGroup]="forgotpasswordForm"
        (ngSubmit)="onForgotPasswordFormSubmit()" id="forgotpassword-form" novalidate>
        <div class="forgotpassword__wrapper">
            <div class="headline">
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="d-flex flex-row label-info mt-4">
                        <label class="w-100" for="email">{{ 'LOGIN.EMAIL' | translate }}</label>
                        <div *ngIf="forgotpasswordFormControls.email?.invalid && (forgotpasswordFormControls.email?.dirty || forgotpasswordFormControls.email?.touched)"
                            class="alert">
                            <div *ngIf="forgotpasswordFormControls.email?.errors?.['required']">
                                <i class="pi pi-info-circle error-icon"
                                    pTooltip="{{ 'INFO.EMAIL_REQUIRED' | translate }}" tooltipPosition="top"></i>
                            </div>
                            <div *ngIf="forgotpasswordFormControls.email?.errors?.['email']">
                                <i class="pi pi-info-circle error-icon"
                                    pTooltip="{{ 'INFO.INVALID_EMAIL' | translate }}" tooltipPosition="top"></i>
                            </div>
                        </div>
                    </div>
                    <input type="email" id="email" formControlName="email" name="email"
                        placeholder="{{ 'INFO.PLACEHOLDER' | translate }}">
                </div>
                <div class="col-12">
                    <button [disabled]="!forgotpasswordForm.valid" class="sendmail-button button full">{{
                        'INFO.SEND_MAIL' | translate }}</button>
                    <mat-spinner *ngIf="loadingPage" class="sign-in-spinner"></mat-spinner>
                </div>
            </div>
        </div>
    </form>
</section>